import { PopupButtonControl } from './popup_button_control.js';

class ComboboxControl extends PopupButtonControl {
  acceptSelected() {
    this.imageButton.src = this.selectedItemImage.src;
    this.imageButton.title = this.selected.title;

    super.acceptSelected();
  }

  setItems(items) {
    super.setItems(items);

    this.selected = this.datalistItems.firstElementChild;
    this.acceptSelected();
  }
}

export { ComboboxControl };
